import * as R from 'ramda'
import moment from 'moment'

export let sort = (collection, field) => (
	R.sort((prev, next) =>
		(prev[field] > next[field])? 1
			: (prev[field] < next[field])? -1
				: 0
	, R.filter(x=>x)(R.values(collection)))
)

export let sortTasks = (collection) => (
	R.sort((task, taskNext) =>
		(task.urgent && !taskNext.urgent)? -1
			: (!task.urgent && taskNext.urgent)? 1
				: (task.schedule && taskNext.schedule && moment(task.schedule.curDue).format("x") < moment(taskNext.schedule.curDue).format("x"))? -1
					: (task.schedule && taskNext.schedule && moment(task.schedule.curDue).format("x") > moment(taskNext.schedule.curDue).format("x"))? 1
						: (task.dependsOnEnded && !taskNext.dependsOnEnded)? -1
							: (!task.dependsOnEnded && taskNext.dependsOnEnded)? 1
								:(task.doneTime > taskNext.doneTime)? 1
									: (task.doneTime < taskNext.doneTime)? -1
										: (task.taskContent > taskNext.taskContent)? 1
											: (task.taskContent < taskNext.taskContent)? -1
												: 0
	, R.values(collection))
)
export let sortProjects = (collection) => {
	let taskBasedCollection = R.map(project => sortTasks(project.tasksObj)[0], collection)
	taskBasedCollection = R.filter(project=> !!project, R.values(taskBasedCollection))
	let sortedByTasks = sortTasks(taskBasedCollection)
	return(
		R.filter( project => !!project, R.map(task => (task)?collection[task.projectID]: undefined ,sortedByTasks))
	)
}
export let sortSev = (collection, fieldName1, fieldName2, optBool, noFilter) => (
	R.sort((prev, next) => {
		if(optBool && prev[optBool] && !next[optBool]){
			return -1
		} else if(optBool && !prev[optBool] && next[optBool]){
			return 1
		}

		return ((prev[fieldName1] + prev[fieldName2]) > (next[fieldName1] + next[fieldName2]))? 1
					: ((prev[fieldName1] + prev[fieldName2]) < (next[fieldName1] + next[fieldName2]))? -1
						: ((prev[fieldName1] + prev[fieldName2]) > (next[fieldName1] + next[fieldName2]))? 1
							: ((prev[fieldName1] + prev[fieldName2]) < (next[fieldName1] + next[fieldName2]))? -1
								: 0
	}, noFilter? R.values(collection) : R.filter(x=>x[fieldName1] + x[fieldName2])(R.values(collection)))
)
export let getByType = (state, type) => R.indexBy(
	R.prop('_id')
	, R.filter(
		doc =>
			doc.type == type
		  , R.values(state.data.db)
	)
)
export let sortCallback = (collection, fieldName, callback) => (
	R.sort((prev, next) =>
		(callback(prev, next) != false)? callback(prev, next) :
			(prev[fieldName] > next[fieldName])? 1
				: (prev[fieldName] < next[fieldName])? -1
					: 0
	, R.values(collection))
)
export let sortSevDesc = (collection, fieldName1, fieldName2) => (
	R.reverse(sortSev(collection, fieldName1, fieldName2, false, true))
)
export let sortSevF = (collection, props) => (
	R.sort(
		(prev, next) =>
			(prev[props.fieldName1] > next[props.fieldName1])? (props.asc)? 1: -1
				: (prev[props.fieldName1] < next[props.fieldName1])? (props.asc)? -1: 1
				: (parseInt(prev[props.fieldName2]) < parseInt(next[props.fieldName2]))? (props.asc)? 1: -1
				: (parseInt(prev[props.fieldName2]) > parseInt(next[props.fieldName2]))? (props.asc)? -1: 1
				: 0
	, R.values(collection))
)
export let beautifyPhone = (str) =>{
	if(str === undefined) return ''
	let mask = '(***) ***-****'
	let retNumber = mask
	str = str.replace(/\D/g, '').trim()
	for(var i = 0; i < mask.length; i++){
		retNumber = retNumber.replace('*', (str[i] || '_'))
	}
	return retNumber;
}
export let beautifyPrice = (str) => {
	let main = str.includes('.') && str.substr(0, str.indexOf('.')) || str
	let coins = str.includes('.') && str.substr(str.indexOf('.')) || '.00';
	main = main.replace(/\D/g, '')
    while(main[0] == '0'){
        main = main.substr(1)
    }
	if(!main.length) main = '0'
	let splitted = R.splitEvery(3, main.split('').reverse().join(''))
	let restore = R.map(spl => spl.split('').reverse().join(''), splitted.reverse()).join(',')
	return restore + coins + (coins.length<3 && '0' || '')
}

export let stringifyNumber = (n) => {
	let special = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth', 'ninth', 'tenth', 'eleventh', 'twelvth', 'thirteenth', 'fourteenth', 'fifteenth', 'sixteenth', 'seventeenth', 'eighteenth', 'nineteenth']
	let deca = ['twent', 'thirt', 'fourt', 'fift', 'sixt', 'sevent', 'eight', 'ninet']

  	if (n < 20) return special[n];
  	if (n%10 === 0) return deca[Math.floor(n/10)-2] + 'ieth';
  	return deca[Math.floor(n/10)-2] + 'y-' + special[n%10];
}
export let dataURItoBlob = (dataURI) => {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0)
        byteString = atob(dataURI.split(',')[1]);
    else
        byteString = unescape(dataURI.split(',')[1]);

    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], {type:mimeString});
}
export let blobToBase64 = function(blob, cb) {
    var reader = new FileReader();
    reader.onload = function() {
	    var dataUrl = reader.result;
	    var base64 = dataUrl.split(',')[1];
	    cb(base64);
    };
    reader.readAsDataURL(blob);
};
export let  getCors = (address, callBack) => {
	if(typeof address != 'string' || !address.length) return
		address = address.trim().replace(/\s/g, '+')
		var request = new XMLHttpRequest();
		function onLoad() {
			if(request.responseText){
				let resp = JSON.parse(request.responseText)
				if((resp.results[0])){
					callBack(
						resp.results[0].geometry.location
					)
				}
			}
		};

		function onTimeout() {
				console.log('Timeout');
				console.log(request.responseText);
		};

		function onError(err) {
				console.log('General network error');
			console.error(err)
				console.log(request.responseText);
		};

		request.onload = onLoad;
		request.ontimeout = onTimeout;
		request.onerror = onError;
		request.open('GET', `https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=AIzaSyD9nTB0Zj_EkiV1qMHp2Fm1d5xN64wnoFM`);
		request.send();
}

export let sortTransactions = (collection) => {
	return R.sort(
		(prev, next) =>{
			let prevPaid = (typeof prev.isPaid == "string")? prev.isPaid == "true" : prev.isPaid
			let nextPaid = (typeof next.isPaid == "string")? next.isPaid == "true" : next.isPaid
			return(!prevPaid && nextPaid)? -1
				: (prevPaid && !nextPaid)? 1
					: (prev.dueDate < next.dueDate)? -1
						: (next.dueDate < prev.dueDate)? 1
									: 0
		}
	  , R.values(collection)
	)
}
function removePoisonChars(name){
	name = name.replace(/\/|>|<|\||:|&|\+|\#|\!/g, '_')
	if(name.indexOf("_") == 0){
		name = name.slice(1)
		return removePoisonChars(name)
	}
	return name
}

export let addTimestampToFileName = (name, timestamp) => {
	name = removePoisonChars(name)
	let res = name.split('.')
	res[0] = res[0] + '_' + moment(timestamp).format("YYYY-MM-DD_hh-mm-ss")
	res = res.join('.')
	return res
}
let getAllChannels = data => R.pipe(R.values, R.filter(x => x.type == "owner"), R.map(x => x._id), R.concat(["manager"]))(data)

export let getChannelsByObject = (obj, data) =>{
	let object = (obj.type == 'comment' || obj.type == 'attachment') ? data[obj.objectID] : obj
	if(object.type == "comment" && obj.type == "attachment") object = data[object.objectID]
	if(object.type == "notification") object = data[data[object.commentID].objectID]
	let llEntities = ["application", "attachment", "comment", "notification", "lease", "listing", "manager", "property", "project", "task", "term", "transaction/bill", "transaction/invoice", "transaction/invoice-payment", "owner"]
	// Manager channel
	if(llEntities.indexOf(obj.type) == -1) return ["manager"]
	//if(obj.type == "notification") return ["manager", obj.to]
	// Landlord channel
	if(object.type == "owner") return ["manager", object._id]
	if(object.type == "manager") return getAllChannels(data)
	let propertyID = (obj.type == "attachment" && object.type == "application") ?
						undefined
						:
						object.type == 'lease' ?
							object.parentID ? data[object.parentID].propertyID : object.propertyID
							:
							object.type == "task" ?
								data[object.projectID].propertyID
								:
								object.type == 'property' ?
									object._id
									:
									object.propertyID
	if(!propertyID || propertyID == "All"){
		return ["manager"]
	} else {
		return data[propertyID].ownerID ? ["manager", data[propertyID].ownerID] : ["manager"]
	}
}

export let parsePeriod = period => {
	period = period && period.toString()
	if(period == "YTD") {
		return ({
			from: moment(moment().year(), "YYYY").format("YYYY-MM-DD")
		  , to: moment().format("YYYY-MM-DD")
		})
	} else if(period == "YTM"){
		return ({
			from: moment(moment().year(), "YYYY").format("YYYY-MM-DD")
		  , to: moment().startOf('month').format("YYYY-MM-DD")
		})
	}else if(period && period.length == 4) {

		return ({
	  		from: moment(period, "YYYY").format("YYYY-MM-DD")
	  	  , to: moment(period, "YYYY").add(1, 'year').subtract(1, "day").format("YYYY-MM-DD")
		})
	} else if (period == 'projected') {
		return ({
	  		from: moment().startOf('month').format("YYYY-MM-DD")
	  	  , to: moment().endOf('year').format("YYYY-MM-DD")
		})
	}
	return ({
		from: moment(period, "MMM YY").format("YYYY-MM-DD")
	  , to: moment(period, "MMM YY").add(1, "month").subtract(1, "day").format("YYYY-MM-DD")
	})

}
/*

	: (moment(prev.dueDate).startOf('day').isBefore(moment(next.dueDate).startOf('day')))? -1
		: (moment(next.dueDate).startOf('day').isBefore(moment(prev.dueDate).startOf('day')))? 1
	: (
			`${(prev.tenant)? prev.tenant.firstName: (prev.vendor)? prev.vendor: ''} ${(prev.tenant)? prev.tenant.lastName: ''}`
		  < `${(next.tenant)? next.tenant.firstName: (next.vendor)? next.vendor: ''} ${(next.tenant)? next.tenant.lastName: ''}`
	  )? -1
		: (
				`${(prev.tenant)? prev.tenant.firstName: (prev.vendor)? prev.vendor : ''} ${(prev.tenant)? prev.tenant.lastName: ''}`
			  > `${(next.tenant)? next.tenant.firstName: (next.vendor)? next.vendor :  ''} ${(next.tenant)? next.tenant.lastName: ''}`
		  )? 1
*/



// WEBPACK FOOTER //
// ./src/utils/stuff.js